<template>
  <div class="bg_box "
       v-loading="firstLoading"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <!--顶部banner-->
    <Banner :form.sync="form" :send-message="sendMessage"/>

    <div class="dashboard-container "
    >

      <!--时间范围选择-->
      <TimeSelect :form.sync="form" :send-message="sendMessage"/>


      <div class="dashboard-layout">
        <!-- 左侧面板 -->
        <div class="panel-group left-panel">

          <!--兵工场-->
          <template v-if="form.module == 1">
            <!--销售数据-->
            <Salesdata :name="get_time()"
                       :module="form.module"
                       :salesdata="detail.sales_block"/>
            <!--分销者排行-->
            <TheCHarts :name="get_time()"
                       :fx_user_detail_rank_block="detail.fx_user_detail_rank_block"
                       :rankblock="detail.fx_user_rank_block"
                       :form.sync="form"
                       :send-message="sendMessage"/>
          </template>
          <!--机构-->
          <template v-if="form.module == 2">
            <!--销售数据-->
            <Salesdata :name="get_time()"
                       :module="form.module"
                       :salesdata="detail.sales_block"/>
            <!--招商排行-->
            <InvestmentRank :name="get_time()"
                            :institution_partner_detail_rank_block="detail.institution_partner_detail_rank_block"
                            :rankblock="detail.institution_partner_rank_block"
                            :form.sync="form"
                            :send-message="sendMessage"/>
          </template>
          <!--分销者-->
          <template v-if="form.module == 3">
            <!--销售数据-->
            <Salesdata :name="get_time()"
                       :module="form.module"
                       :salesdata="detail.sales_block"/>
            <!--分销者排行-->
            <TheCHarts :name="get_time()"
                       :fx_user_detail_rank_block="detail.fx_user_detail_rank_block"
                       :rankblock="detail.fx_user_rank_block"
                       :form.sync="form"
                       :send-message="sendMessage"/>
          </template>
          <!--产品-->
          <template v-if="form.module == 4">
            <!--产品数据汇总-->
            <ProductDataSummary :name="get_time()" :salesdata="detail.product_census_block"/>
            <!--出单产品增长情况-->
            <ProwthSituation :name="get_time()" :datas="detail.product_sales_chart_block"/>
          </template>
          <!--商家-->
          <template v-if="form.module == 8">
            <!-- 成交排行-->
            <DealRank :name="get_time()"
                      :datas="detail.deal_rank_block"/>
            <!--店铺销售额占比-->
            <ProductCategory
                titleTime="店铺销售额占比"
                :category_sales_pie_block="detail.shop_sales_proportion_block"
                :showLabel="false"
            :legendPage="true"/>
          </template>

        </div>

        <!-- 中间内容区 -->
        <div class="center-content">
          <!--GMV-->
          <GMV :name="get_time()" :module="form.module" :GMVform="detail.gmv_block"/>

          <!--兵工场-->
          <template v-if="form.module == 1">
            <!--地图-->
            <div class="map-container">
              <Map :timeLabel="get_time()"
                   :module="form.module"
                   :platform="form.platform"
                   :datas="detail.bing_factory_map_block"
                   :handler-db-click="mapBgcDbClick"/>
            </div>
          </template>
          <!--机构-->
          <template v-if="form.module == 2">
            <OrgPie
                title="机构销售概况"
                :datas="detail.institution_sales_pie_block"
                :onSectorDbClick="orgPieDbClick"/>

          </template>
          <!--分销者-->
          <template v-if="form.module == 3">
            <!--地图-->
            <div class="map-container">
              <Map :timeLabel="get_time()"
                   :module="form.module"
                   :platform="form.platform"
                   :datas="detail.fx_user_map_block"/>
            </div>
          </template>
          <!--产品-->
          <template v-if="form.module == 4">
            <!--地图-->
            <div class="map-container">
              <Map :timeLabel="get_time()"
                   :module="form.module"
                   :platform="form.platform"
                   :datas="detail.region_block"/>
            </div>
          </template>

          <!--商家-->
          <template v-if="form.module == 8">
            <FundFlow :chartblock="detail.fund_flow_block"/>
          </template>
        </div>

        <!-- 右侧面板 -->
        <div class="panel-group right-panel">
          <!--兵工场-->
          <template v-if="form.module == 1">
            <!--订单数据,GMV数据-->
            <RightTop :name="get_time()" :chartblock="detail.sales_chart_block"/>
            <!--兵工场排行-->
            <RightBottom :name="get_time()" :factoryrankblock="detail.bing_factory_rank_block"/>
          </template>
          <!--机构-->
          <template v-if="form.module == 2">
            <!--订单数据,GMV数据-->
            <RightTop :name="get_time()" :chartblock="detail.sales_chart_block"/>
            <!--机构销售榜单-->
            <SalesRanki :name="get_time()" :datas="detail.institution_sales_rank_block"/>
          </template>
          <!--分销者-->
          <template v-if="form.module == 3">
            <!--订单数据,GMV数据-->
            <RightTop :name="get_time()" :chartblock="detail.sales_chart_block"/>
            <!--达人销售排行-->
            <ExpertSalesRank :name="get_time()"
                             :datas="detail.customers_sales_rank_block"/>
          </template>
          <!--产品-->
          <template v-if="form.module == 4">
            <!--产品销售排行-->
            <ProductSalesRank :name="get_time()"
                              :datas="detail.product_sales_rank_block"/>
            <!--产品分类-->
            <ProductCategory :titleTime="get_time()+'产品分类'"
                             :category_sales_pie_block="detail.product_category_chart_block"
                             :select_no="['其他']"
            />
          </template>
          <!--商家-->
          <template v-if="form.module == 8">
            <!-- 订单监控-->
            <OrderMonitor :datas="detail.order_monitor_block"/>
            <!-- 仓库信息-->
            <Warehouse :name="get_time()"
                      :datas="detail.warehouse_info_block"/>
          </template>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Map from '../map.vue'
import Home from '../home.vue'
import GMV from './components/gmv.vue'
import Socket from '@/utils/websocket'
import Salesdata from './components/salesdata.vue'
import TheCHarts from './components/theCharts.vue'
import RightTop from './components/right_top.vue'
import RightBottom from './components/right_bottom.vue'
import Banner from './components/banner.vue'
import TimeSelect from './components/timeSelect.vue'
import InvestmentRank from './components/orgComponents/InvestmentRank.vue'
import SalesRanki from './components/orgComponents/salesRanki.vue'
import {tFormatDate} from '@/utils/utils';
import OrgPie from '@/components/charts/pie3d.vue'
import ExpertSalesRank from './components/fxzComponents/ExpertSalesRank.vue'
import BestSellersTop10 from "./components/bgcComponents/bestSellersTop10.vue";
import ProductCategory from '@/components/charts/pie2d.vue'
import ProductSalesRank from '../index/components/productComponents/ProductSalesRank.vue'
import ProductDataSummary from '../index/components/productComponents/productDataSummary.vue'
import ProwthSituation from '../index/components/productComponents/prowthSituation.vue'
import Flights from '@/components/charts/flights.vue'
import DealRank from './components/merchantComponents/dealRank.vue'
import OrderMonitor from './components/merchantComponents/orderMonitor.vue'
import SalesRevenue from '@/components/charts/pie2d.vue'
import FundFlow from './components/merchantComponents/fundFlow.vue'
import Warehouse from './components/merchantComponents/warehouse.vue'

export default {
  name: 'DashboardLayout',
  components: {
    BestSellersTop10,
    Map,
    Home,
    GMV,
    Salesdata,
    TheCHarts,
    RightTop,
    RightBottom,
    SalesRanki,
    Banner,
    TimeSelect,
    InvestmentRank,
    ExpertSalesRank,
    ProductCategory,
    ProductSalesRank,
    ProductDataSummary,
    ProwthSituation,
    OrgPie,
    Flights,
    DealRank,
    OrderMonitor,
    SalesRevenue,
    FundFlow,
    Warehouse
  },
  data() {
    return {

      firstLoading: true,

      socket: null,
      messages: [],
      error: null,
      wsUrl: ``,

      // wsUrl: 'wss://mp-dev.bobiton.com:9503/wsDataScreen/ws',

      form: {
        module: 8, // 模块 1兵工场 2机构 3分销者 4产品 8商家
        platform: 1, // 平台 1快手 2视频号 3抖音  商家用：0旺店通
        date_type: 0, // 时间类型：0时间选择 1自定义时间
        date_value: 1, // 时间选择 1今日 2昨日 3本月 4上月（当时间类型为0时必传 为1的时候传0）
        date_start: '', // 开始时间（当时间类型为1时必传 为0的时候传''）
        date_end: '', // 结束时间（当时间类型为1时必传 为0的时候传''）
        position: 0 // 是否拿取分销者数据
      },
      detail: {
        gmv_block: {
          current_sum_pay_amount: 0,//当前筛选gmv
          current_count_order: 0,//当前筛选订单量
          previous_sum_pay_amount: 0,//上期gmv
          previous_desc: '--',//上期描述文字
          gmv_growth: 0,//同比增长
          all_sum_pay_amount: 0,//累计gmv

          //  ============ 产品 ============
          yesterday_product_count: 0,
        }, // gmv中心块
        sales_block: {
          current_count_order: 0,
          current_settle_count_order: 0,
          current_sum_pay_amount: 0,
          current_settle_sum_pay_amount: 0,
          current_sum_service_amount: 0,
          current_settle_sum_service_amount: 0,
          current_send_sample_count: 0,
          current_distinct_talent_num: 0
        }, // 销售数据（左上）
        bing_factory_rank_block: {},
        fx_user_rank_block: [], // 分销者销售排行（左下）
        sales_chart_block: {}, // 订单折线图（右上）
        fx_user_detail_rank_block: {
          census_data: {},
          current_page: 0,
          last_page: 0,
          list: [],
          per_page: 10,
          total: 0
        },
        bing_factory_map_block: [],//省份地图


        //  ============ 机构 ============
        institution_sales_pie_block: [],//机构销售概况
        institution_partner_rank_block: [],//招商排行
        institution_partner_detail_rank_block: {//招商排行详情
          census_data: {},
          current_page: 0,
          last_page: 0,
          list: [],
          per_page: 10,
          total: 0
        },
        institution_sales_rank_block: {},


        //  ============ 分销者 ============
        fx_user_map_block: [],//省份地图（分销者模块）
        customers_sales_rank_block: [],//达人销售排行


        //  ============ 产品 ============
        product_census_block: {},//产品数据汇总
        product_category_chart_block: {},//产品分类
        product_sales_chart_block: [],//出单产品增长情况（左下）
        region_block: [],//地图数据
        product_sales_rank_block: [],//产品销售排行


        //  ============ 商家 ============
        deal_rank_block:{
          shop_data:[],
          product_data:[],
        },//成交排行榜（左上）
        shop_sales_proportion_block:{},//店铺销售占比 左下
        fund_flow_block:{},//店铺资金流向 中
        order_monitor_block:{},//订单监控 右上
        warehouse_info_block:[],// 仓库信息 右下


      },

    }
  },
  methods: {
    get_time() {
      if (this.form.date_type === 0) {
        if (this.form.date_value === 1) {
          return '今日'
        } else if (this.form.date_value === 2) {
          return '昨日'
        } else if (this.form.date_value === 3) {
          return '本月'
        } else if (this.form.date_value === 4) {
          return '上月'
        } else {
          return `自定义时间`
        }
      } else {
        return `本时段`
      }

    },
    // ================ 兵工场 ================
    mapBgcDbClick(params) {
      if (params.data && params.data.factory_uuid) {
        this.$router.push(`/BgcOne?bgcId=${params.data.factory_uuid}&bgcName=${params.data.factory_name}`);
      }
    },

    // ================ 机构 ================
    orgPieDbClick(params) {
      this.$router.push(`/OrgOne?orgId=${params.data.institution_uuid}&orgName=${params.data.institution_name}&platform=${this.form.platform}`)
    },

    // 连接WebSocket
    connectWebSocket() {
      if (this.socket) {
        this.socket.close();
      }

      this.socket = new Socket(
          this.wsUrl,
          this.handleMessage,
          this.handleError
      );

      // 添加连接成功回调
      this.socket.onOpen = () => {
      };

      this.socket.connect();
    },


    // 处理接收到的消息
    handleMessage(data) {
      if (data == 'pong') {
        return
      }
      if (data.data === '连接成功') {
        this.sendMessage(); // 确保连接成功后再发送
      } else if (data.code == 400) {
        this.firstLoading = false
        this.$message.error(data.message);
      } else {
        this.firstLoading = false
        // gmv中心块
        if (data.data.gmv_block) {
          this.detail.gmv_block = data.data.gmv_block
        }
        // 销售数据（左上）
        if (data.data.sales_block) {
          this.detail.sales_block = data.data.sales_block
        }
        // 分销者销售排行（左下）
        if (data.data.fx_user_rank_block) {
          this.detail.fx_user_rank_block = data.data.fx_user_rank_block
        }
        // 分销者销售排行列表详情（左下）
        if (data.data.fx_user_detail_rank_block) {
          this.detail.fx_user_detail_rank_block = data.data.fx_user_detail_rank_block
        }
        // 订单折线图（右上）
        if (data.data.sales_chart_block) {
          this.detail.sales_chart_block = data.data.sales_chart_block
        }
        // 兵工场排行(右下)
        if (data.data.bing_factory_rank_block) {
          this.detail.bing_factory_rank_block = data.data.bing_factory_rank_block
        }
        // 省份地图
        if (data.data.bing_factory_map_block) {
          this.detail.bing_factory_map_block = data.data.bing_factory_map_block
        }
        // 省份地图（分销者模块）
        if (data.data.fx_user_map_block) {
          this.detail.fx_user_map_block = data.data.fx_user_map_block.map(m => ({
            ...m,
            factory_name: m.province_name,
            status: 0
          }))
        }
        if (data.data.customers_sales_rank_block) {
          this.detail.customers_sales_rank_block = data.data.customers_sales_rank_block
        }

        // ================== 机构 ==================
        // 机构销售概况
        if (data.data.institution_sales_pie_block) {
          this.detail.institution_sales_pie_block = data.data.institution_sales_pie_block
        }
        // 招商排行
        if (data.data.institution_partner_rank_block) {
          this.detail.institution_partner_rank_block = data.data.institution_partner_rank_block
        }
        // 招商排行（详情
        if (data.data.institution_partner_detail_rank_block) {
          this.detail.institution_partner_detail_rank_block = data.data.institution_partner_detail_rank_block
        }
        // 招商排行（详情
        if (data.data.institution_sales_rank_block) {
          this.detail.institution_sales_rank_block = data.data.institution_sales_rank_block
        }


        // ================== 产品 ==================
        // 产品数据汇总
        if (data.data.product_census_block) {
          this.detail.product_census_block = data.data.product_census_block
        }
        // 产品销售排行
        if (data.data.product_sales_rank_block) {
          this.detail.product_sales_rank_block = data.data.product_sales_rank_block
        }
        // 产品分类
        if (data.data.product_category_chart_block) {
          this.detail.product_category_chart_block = data.data.product_category_chart_block
        }
        // 出单产品增长情况（左下）
        if (data.data.product_sales_chart_block) {
          this.detail.product_sales_chart_block = data.data.product_sales_chart_block
        }
        // 地图数据
        if (data.data.region_block) {
          this.detail.region_block = data.data.region_block.map(m => ({
            ...m,
            factory_name: m.province_name,
            status: 0
          }))
        }


        // ================== 商家 ==================
        // 成交排行榜（左上）
        if (data.data.deal_rank_block) {
          this.detail.deal_rank_block = data.data.deal_rank_block
        }
        // 店铺销售占比 左下
        if (data.data.shop_sales_proportion_block) {
          this.detail.shop_sales_proportion_block = {
            pie_data:data.data.shop_sales_proportion_block.map(m=>({
              cate_name:m.name,
              count_product_value:m.amount,
            })),
          }
        }
        // 店铺资金流向 中
        if (data.data.fund_flow_block) {
          this.detail.fund_flow_block = data.data.fund_flow_block
        }
        // 订单监控 右上
        if (data.data.order_monitor_block) {
          this.detail.order_monitor_block = data.data.order_monitor_block
        }
        // 仓库信息 右下
        if (data.data.warehouse_info_block) {
          this.detail.warehouse_info_block = data.data.warehouse_info_block
        }

      }
    },

    // 处理错误
    handleError(error) {
      this.error = error.message || 'WebSocket连接错误'
    },
    // 发送消息
    sendMessage() {
      if (this.socket) {
        this.firstLoading = true
        this.socket.send(this.form)
      } else {
        this.error = '请先连接WebSocket'
      }
    },

    // 关闭连接
    closeWebSocket() {
      if (this.socket) {
        this.socket.close()
        this.socket = null
      }
    }
  },

  // 组件销毁时关闭WebSocket
  beforeDestroy() {
    if (this.socket) {
      this.socket.close()
    }
  },
  mounted() {
    this.connectWebSocket()
  },
}
</script>

<style lang="scss" scoped>

.bg_box {
  //width: 100%;
  height: 100vh;
  background-image: url(../../assets/iamge_bg.png);
  background-size: 100% 100vh;
}

.dashboard-container {
  padding: 0 20px;
}


.dashboard-layout {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.panel-group {
  display: flex;
  flex-direction: column;

  &.left-panel {
    margin-right: auto;
  }

  &.right-panel {
    margin-left: auto;
  }
}

.panel-item {
  width: 490px;
  height: 420px;
  background: url(../../assets/_s-image_sector_bg.png) no-repeat;
  background-size: 100% 100%;

  &.first-panel {
    margin: 30px 0 35px 0;
  }
}

.center-content {
  width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
}


.map-container {
  width: 100%;
  height: 640px;
}


// ::v-deep .el-input__icon {
//   line-height: 30px !important;
//   font-size: 22px !important;
//   color: #00A8FF !important;
// }

</style>